import React from 'react'
import { Container } from 'reactstrap'

import emptyCartImg from '../../assets/images/icons/EmptyCart.png'

const CartEmpty = () => {
    return (
        <Container className="empty-cart">
            <img src={emptyCartImg} alt="Empty Cart" className="empty-cart__icon" />
            <h1 className="empty-cart__title">Your cart is empty!</h1>
            {/* <p className="empty-cart__subtitle">Check out our today’s menu.</p> */}
        </Container>
    )
}

export default CartEmpty
